import * as ko from "knockout";
import Bao from "./../services/bao-service";
import NodeViewModel from "./../factories/node-view-model";
import ChildTabViewModel from "./../factories/child-tab-view-model";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../factories/tab-page";
import BaoDialogViewModel from "./../factories/bao-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../bindings/bao-searcher";
import "./../bindings/bao-toolbar2";
import "./../bindings/sorting";
import "./../bindings/bao-number-box";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
function TicketEscalationTabModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(this, tabPage, parent);
    tabPage.ViewModel(self);
    self.Bao = Bao;
    self.Ticket = parent;
    self.TicketEscalationTypeJs = ko.observable("1");
    self.ReactedOnJs = ko.observable();
    self.TicketEscalationDefinitionId = ko.observable();
    self.TicketEscalationDefinitionName = ko.observable();
    self.SelectedTicketEscalationDefinition = ko.observable();
    self.IgnoreSave = ko.observable(false);
    self.ManualReactionDateJs = ko.observable();
    self.ManualSolutionDateJs = ko.observable();
    self.ManualNotifyUserId = ko.observable();
    self.ReactionTimeBySLA = ko.observable();
    self.SolutionTimeBySLA = ko.observable();
    self.TicketEscalationTypeJs.subscribe(function () {
        tabPage.IsLoading(true);
        self.SaveSessionModel().then(function () {
            self.Ticket.UpdateReactedButtonVisible().then(function () {
                tabPage.IsLoading(false);
            });
        });
    });
    self.ManualReactionDateJs.subscribe(function () {
        tabPage.IsLoading(true);
        self.SaveSessionModel().then(function () {
            self.Ticket.UpdateReactedButtonVisible().then(function () {
                tabPage.IsLoading(false);
            });
        });
    });
    self.ManualSolutionDateJs.subscribe(function () {
        self.SaveSessionModel();
    });
    self.ManualNotifyUserId.subscribe(function () {
        self.SaveSessionModel();
    });
    self.SelectedTicketEscalationDefinition.subscribe(function (item) {
        self.IgnoreSave(true);
        tabPage.IsLoading(true);
        if (item != null) {
            self.TicketEscalationDefinitionName(item.Name);
            self.ReactionTimeBySLA(item.ReactionTime);
            self.SolutionTimeBySLA(item.SolutionTime);
        }
        else {
            self.TicketEscalationDefinitionName("");
            self.ReactionTimeBySLA(null);
            self.SolutionTimeBySLA(null);
        }
        self.IgnoreSave(false);
        self.SaveSessionModel().then(function () {
            self.Ticket.UpdateReactedButtonVisible().then(function () {
                tabPage.IsLoading(false);
            });
        });
    });
    self.ReactedDetailVisible = ko.computed(function () {
        if (!Bao.Utils.String.IsNullOrWhitespace(self.ReactedOnJs())) {
            return true;
        }
        return false;
    });
    self.TicketEscalationDefinitionDelete = function () {
        tabPage.IsLoading(true);
        self.IgnoreSave(true);
        self.TicketEscalationDefinitionId(null);
        self.TicketEscalationDefinitionName("");
        self.ReactionTimeBySLA(null);
        self.SolutionTimeBySLA(null);
        self.IgnoreSave(false);
        self.SaveSessionModel().then(function () {
            self.Ticket.UpdateReactedButtonVisible().then(function () {
                tabPage.IsLoading(false);
            });
        });
    };
    self.SetValuesByModel = function (result) {
        self.IgnoreSave(true);
        self.TicketEscalationDefinitionId(result.TicketEscalationDefinitionId);
        self.TicketEscalationDefinitionName(result.TicketEscalationDefinitionName);
        self.ReactionTimeBySLA(result.ReactionTimeBySLA);
        self.SolutionTimeBySLA(result.SolutionTimeBySLA);
        self.IgnoreSave(false);
    };
    self.SaveSessionModel = function () {
        var def = $.Deferred();
        if (self.IgnoreSave() == false) {
            var model = ko.map.toJS(self);
            delete model.Ticket;
            delete model.SelectedTicketEscalationDefinition;
            return Bao.post("Ticket/SaveTicketEscalation", JSON.stringify({
                ticketEscalationModel: model,
                sessionTabId: self.Ticket.TabPage.SessionTabId
            }), function (result) {
                def.resolve();
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    self.init = function () {
        return self.PerformRefresh();
    };
    self.PerformRefresh = function () {
        return Bao.post("Ticket/GetTicketEscalationModel", JSON.stringify({
            sessionTabId: self.Ticket.TabPage.SessionTabId,
            ticketId: self.Ticket.TicketId()
        }), function (result) {
            self.IgnoreSave(true);
            ko.map.fromJS(result, self, tabPage.DirtyFlag);
            tabPage.DirtyFlag.reset();
            self.IgnoreSave(false);
        });
    };
}
export default TicketEscalationTabModel;